import { QDefaultFontQuery } from '../_graphql/queries/documents/QDefaultFont';
import useFetchQuery from './useFetchQuery';

const useDefaultFont = () => {
  const { defaultFont, isLoading } = useFetchQuery({
    query: QDefaultFontQuery,
    args: {},
    dataProp: 'defaultFont',
    defaultData: {}
  });

  return {
    defaultFont,
    isLoading
  };
};
export default useDefaultFont;
